
export default {
  props: ['error'],
  layout: 'error', // you can set a custom layout for the error page
  async asyncData({ res }) {
    res.statusCode = 404
  },
}
